import { createFileRoute } from "@tanstack/react-router"

import { ExpertsScreen } from "@/features/experts/experts-screen"

/**
 * The expert-management route.
 *
 * A thin wrapper: the screen lives in features/experts so it can be rendered
 * without a router — and so the access-denied branch can be tested directly.
 */
export const Route = createFileRoute("/_panel/experts")({
	component: ExpertsScreen,
})
